import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function createRegexValidator(regex: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const allowedCharacters = new RegExp(regex);
    const hasAllowedCharacters = allowedCharacters.test(control.value);
    if (!hasAllowedCharacters) {
      return { specialCharacters: true };
    }
    return null;
  };
}
